export default __webpack_public_path__ + "static/media/Quintal.317f0371.jpg";